module.exports = __webpack_public_path__ + "static/media/country-flag-sprite.46c95c88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/country-flag-sprite.svg
// module id = 472
// module chunks = 7